var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3666 1.67497C15.507 0.814968 14.3409 0.331787 13.1249 0.331787C11.909 0.331787 10.7429 0.814968 9.88327 1.67497L8.99994 2.55831L8.1166 1.67497C6.32628 -0.115348 3.42359 -0.115348 1.63327 1.67498C-0.157053 3.4653 -0.157054 6.36798 1.63327 8.15831L2.5166 9.04164L8.99994 15.525L15.4833 9.04164L16.3666 8.15831C17.2266 7.2987 17.7098 6.13259 17.7098 4.91664C17.7098 3.70069 17.2266 2.53458 16.3666 1.67497Z",
    fill: "#979EBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartGrey);
export default __webpack_public_path__ + "static/media/heart-grey.f70e73c04e78ad2c8da27a41ad4c6bb1.svg";
export { ForwardRef as ReactComponent };